/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery, registerMutation } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './DraftsFrontendService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService#upsertDraft
 */
export const UPSERT_DRAFT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: 'upsertDraft',
  args: ['idType', 'id', 'genericChannelId', 'timestamp', 'jsonBlob', 'plainTextContent', 'attachments'],
  fetcher(request, ctx) {
    return chirpClient.call(References.upsertDraftRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService#deleteDraft
 */
export const DELETE_DRAFT_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: 'deleteDraft',
  args: ['idType', 'id', 'genericChannelId', 'timestamp'],
  fetcher(request, ctx) {
    return chirpClient.call(References.deleteDraftRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * @deprecated due to potential cache collision issues. Use from the .dfc.new.ts file instead.
 * This will also change the data structure from 'data.fieldName' to 'data.result'.
 *
 * Recomended usage: Use hooks from .hooks.ts file instead.
 *
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.cv.threads.drafts.rpc.DraftsFrontendService#getDrafts
 */
export const GET_DRAFTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getDrafts',
  args: ['idType', 'id'],
  fetcher(request, ctx) {
    return chirpClient.call(References.getDraftsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});